var map = {
	"./asbest.jpg": 6529,
	"./asfalt.jpg": 8673,
	"./batterier.jpg": 6105,
	"./beton-og-natursten.jpg": 5108,
	"./bilbatterier.jpg": 9189,
	"./bloed-plast.jpg": 3423,
	"./boeger.jpg": 4696,
	"./braendbart.jpg": 5348,
	"./brokker.jpg": 624,
	"./byggeri.jpg": 3155,
	"./daek.jpg": 7511,
	"./deponi.jpg": 7868,
	"./drikkedaaser.jpg": 8455,
	"./elektronik.jpg": 452,
	"./elpaerer.jpg": 6870,
	"./farligt-affald.jpg": 4348,
	"./fladskaerme-og-baerbare.jpg": 2733,
	"./flamingo.jpg": 4642,
	"./gips.jpg": 5602,
	"./glas.jpg": 9169,
	"./gummi.jpg": 3662,
	"./haard-pvc.jpg": 6019,
	"./indendoers-trae.jpg": 8095,
	"./jern-og-metal.jpg": 6423,
	"./jord.jpg": 2449,
	"./koeleskabe-frysere.jpg": 4753,
	"./komfurer-vaskemaskiner.jpg": 3740,
	"./ledninger-og-kabler.jpg": 5739,
	"./lysstofroer.jpg": 1890,
	"./mad-og-drikkekartoner.png": 7120,
	"./madaffald.jpg": 7529,
	"./madrasser-sofaer.jpg": 5623,
	"./mellemstort-elektronik-50-120cm.jpg": 4927,
	"./metal.jpg": 8546,
	"./mursten-og-tegl.jpg": 1014,
	"./natur.jpg": 6179,
	"./paller.jpg": 3886,
	"./pap.jpg": 3317,
	"./papir-og-aviser.jpg": 2747,
	"./pet-flasker.jpg": 4678,
	"./plast.jpg": 833,
	"./plasthavemoebler.jpg": 1269,
	"./rockwool-og-glasuld.jpg": 1820,
	"./skaerme-med-billedroer.jpg": 1929,
	"./smaat-elektronik-u-50cm.jpg": 2724,
	"./tagpap.jpg": 4948,
	"./tekstil.jpg": 8389,
	"./tekstiler.jpg": 9964,
	"./toiletter-og-haandvaske.jpg": 9322,
	"./trae.jpg": 6530,
	"./trykflasker.jpg": 9720,
	"./udendoers-trae.jpg": 13,
	"./vinduer.jpg": 7501
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6097;